import { render, staticRenderFns } from "./github.svg.vue?vue&type=template&id=c4cd1e94&"
import script from "./github.svg.vue?vue&type=script&lang=js&"
export * from "./github.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports